import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';

import { AutoTopUpSettings } from './auto-top-up-settings';

export class ReserveSeatDto {
  @IsNumber()
  seat: number;

  @IsString()
  @IsOptional()
  tableId?: string;
}

export class ReserveSeatResponseDto {
  @IsBoolean()
  success: boolean;

  @IsString()
  message: string;

  @IsOptional()
  @IsNumber()
  existingSessionStack: number | undefined;

  @IsOptional()
  @IsNumber()
  reservationExpiresAt: number | null;
}

export class JoinTableDto extends AutoTopUpSettings {
  @IsNumber()
  seat: number;

  @IsNumber()
  amount: number;

  @IsString()
  userOpHash: string;
}
